<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Дополнительное описание</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <slot name="tabs"></slot>
                    <CRow class="pl-3 pb-3" />
                    <CCard>
                        <CCardBody>
                            <CRow>
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">
                                    Создать описание для
                                </CCol>
                                <CCol sm="6">
                                    <CSelect
                                        :options="selectCategories"
                                        :value.sync="selectedCategory"
                                        placeholder=""
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CButton
                                        color="primary"
                                        class="mr-3"
                                        @click="create">Создать</CButton>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                    <CCol>
                        <CRow class="bordered"></CRow>
                        <template v-for="description in descriptions">
                            <CRow :key="`description-${description.id}`" class="bordered py-2">
                                <CCol sm="6" class="d-flex align-items-center">
                                    {{ categoryTitles[+description.category_id] }}
                                </CCol>
                                <CCol sm="6" class="d-flex justify-content-end">
                                    <CButton
                                        color="primary"
                                        class="ml-3"
                                        @click="edit(description)">Редактировать</CButton>
                                    <CButton
                                        color="danger"
                                        class="ml-3"
                                        @click="remove(description.id)">Удалить</CButton>
                                </CCol>
                            </CRow>
                        </template>
                    </CCol>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import TimeSlotsUpdate from '@/components/TimeSlotsUpdate';
    import PromoCovers from '@/components/promo-covers/PromoCovers';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {
        name: 'AdditonalEdit',

        components: {
            RestaurantsTabLinks,
            TimeSlotsUpdate,
            PromoCovers,
        },

        props: {
            entityType: {
                type: String,
                default: ''
            },
            entityId: {
                type: Number,
                default: null
            },
        },

        data() {
            return {
                BUSINESS_TYPE,
                categories: [],
                categoryTitles: {
                    0: 'Весь сервис'
                },
                selectedCategory: null,
                descriptions: [],
            };
        },

        computed: {
            selectCategories() {
                return [
                    {
                        value: null,
                        label: 'Всего сервиса'
                    },
                    ...this.categories.map(item => {
                        return {
                            value: item.id,
                            label: item.title
                        }
                    })
                ]
            }
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id;
                let response = {};
                switch(this.entityType) {
                    case BUSINESS_TYPE.RESTAURANT:
                        response = await Vue.axios.get(`/restaurants/${id}/categories`);
                        this.categories = response.data;
                        break;
                    case BUSINESS_TYPE.GROCER:
                        response = await Vue.axios.get(`/grocers/${id}/categories`);
                        this.categories = response.data;
                        break;
                    case BUSINESS_TYPE.ENTITY:
                        const { data: entity } = await Vue.axios.get(`/entities/get/${ this.entityId }`);
                        response = await Vue.axios.get(`/entities/${ entity.entityType.code }/get-categories/${ this.entityId }`);
                        this.categories = response.data;
                        break;
                }
                for(const category of this.categories) {
                    this.categoryTitles[category.id] = category.title;
                }

                const {data: descriptions } = await Vue.axios.get(`/entity-additional-description/${ this.entityType }/${ this.entityId }`);
                this.descriptions = descriptions;
            },

            async create() {
                this.$router.push(`additional-description/${ this.selectedCategory }`);
            },

            async edit(item) {
                this.$router.push(`additional-description/${ item.category_id }`);
            },

            async remove(id) {
                await Vue.axios.delete(`/entity-additional-description/${ id }`);
                await this.fetch();
            },
        },
    };
</script>

<style scoped>
.bordered {
    border-bottom: 1px solid #d8dbe0;
}
</style>